import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Box,
  Button,
  HStack,
  Text,
  Progress,
  Divider,
} from "@chakra-ui/react";
import { ArrowBackIcon, ArrowForwardIcon, CloseIcon } from "@chakra-ui/icons";
import { cn } from "../../lib/utils";

interface StepperModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
  onSubmit: () => void;
  nextButtonText?: string;
  previousButtonText?: string;
  submitButtonText?: string;
  isNextDisabled?: boolean;
  isSubmitDisabled?: boolean;
  currentStep: number;
  totalSteps: number;
  isLoading?: boolean;
  onReset?: () => void;
}

export const StepperModal: React.FC<StepperModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onNext,
  onPrevious,
  onSubmit,
  nextButtonText = "Next",
  previousButtonText = "Previous",
  submitButtonText = "Submit Request",
  isNextDisabled = false,
  isSubmitDisabled = false,
  currentStep,
  totalSteps,
  isLoading = false,
  onReset,
}) => {
  const handleClose = () => {
    if (onReset) {
      onReset();
    }
    onClose();
  };

  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="2xl"
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent rounded="none">
        <ModalHeader p={0}>
          <div className="flex flex-col w-full gap-6 ">
            <div className="flex w-full min-h-20 justify-end items-center px-6 border-b border-prussianBlue-50">
              <Button
                variant="outline"
                onClick={handleClose}
                rounded="full"
                size="sm"
                w={10}
                h={10}
                type="button"
              >
                <CloseIcon />
              </Button>
            </div>

            <div className="flex flex-col w-full px-6 gap-4">
              <Progress
                value={progressPercentage}
                size="xs"
                colorScheme="flatteredFlamingo"
              />

              <h3 className="text-2xl font-bold text-prussianBlue-500">
                {title}
              </h3>
            </div>
          </div>
        </ModalHeader>

        <ModalBody py={6}>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};